import {Typography} from '~library/atoms/Typography';
import {GiftboxIcon} from '~library/svg/v2/GiftboxIcon';

const MISC_VENDOR = 'gift registry';

export type Registry = {
  id?: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  email_reg_button_url?: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  icon_url?: string;
  iconUrl?: string;
  name: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  sg_icon_url?: string;
  type?: string;
  url: string;
  // biome-ignore lint/style/useNamingConvention: existing error
  vendor_name?: string;
  vendorName?: string;
};

type RegistryVendorProps = {
  type: string;
  registry: Registry;
  dataQaId: string;
};

export const RegistryVendor = ({type, registry, dataQaId}: RegistryVendorProps) => {
  const {name} = registry;
  const iconUrl = registry.iconUrl || registry.icon_url;
  const vendorName = registry.vendorName || registry.vendor_name || registry.name;

  let displayName = name;
  if (vendorName) {
    displayName = vendorName.includes('registry') ? '' : vendorName;
  }

  const isMiscVendor = [registry.name, registry.vendorName].includes(MISC_VENDOR);

  return (
    <div className="view-invitation__registry-vendor__wrapper">
      <a
        href={registry.url || ''}
        className="view-invitation__registry-vendor"
        target="_blank"
        data-qa-id={dataQaId}
        data-impression-tracking="true"
        rel="noopener noreferrer"
      >
        {isMiscVendor ? (
          <GiftboxIcon className="view-invitation__registry-vendor-icon" ratio={1.5} />
        ) : (
          <img src={iconUrl} alt={vendorName} />
        )}
        <Typography variant="link" className="view-invitation__registry-vendor__title" semibold>
          View the {displayName} {type}
        </Typography>
      </a>
    </div>
  );
};
